import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useHistory, useLocation } from 'react-router-dom'
import { data } from './HistoryTableLists'
import { TableComponent } from '../../../../../components/Dashboard/Table'
import { AppStateContext, useRest, useRefreshTransactions } from '../../../../../components/Context'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    paddingTop: theme.spacing(4),
  },
  container: {
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
  table: {
    width: '100%',
  },
}))
interface HistorySectionProps {
  title: string
}

export const History: FC<HistorySectionProps> = ({ title }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const history = useHistory()
  const { rxiosAuth } = useRest()
  const { getIsRefreshTransactions } = useContext(AppStateContext)
  const { saveIsRefreshTransactions } = useRefreshTransactions()
  const { search } = useLocation()
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [refresh, setRefresh] = useState<boolean | undefined>()

  useEffect(() => setRefresh(getIsRefreshTransactions()), [setRefresh, getIsRefreshTransactions])

  const stringParams = new URLSearchParams(search)
  const pageUrl: number | string | null = stringParams.get('page')

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth.get(`${data.request}?page=${page}&count=4`).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setValues(next)
          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error)
          setLoading(false)
        },
        () => {
          setLoading(false)
          saveIsRefreshTransactions(false)
        },
      )
      cleanupFunction = true
    },
    // eslint-disable-next-line
    [history, rxiosAuth],
  )

  useEffect(() => {
    ;(async () => {
      await loadData(pageUrl || '1')
    })()
    // eslint-disable-next-line
  }, [refresh])

  useEffect(() => {
    if (refresh) {
      ;(async () => {
        await loadData('1')
      })()
    }
    // eslint-disable-next-line
  }, [refresh])

  return (
    <Grid container className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} md={6} className={classes.container}>
          <Typography variant={'h6'}>{title}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.table}>
          <TableComponent
            columns={data.columns}
            data={values.items}
            params={values.meta}
            loadData={(pageNumber: number) => loadData(pageNumber)}
            loading={loading}
          />
        </Grid>
      </FormProvider>
    </Grid>
  )
}
